
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ProductInfoModel } from "@/model/HenganLoadingPlanModels";
import { isEmpty, toUpper } from "lodash";
import { LoadingPlanType } from "@/views/sales-management/SalesBookingOrderManagement.vue";
import { getLoadingPlanProduct } from "@/api/booking-order";

/**
 * 报关单据表格
 */
@Component({
  name: "DeclarationDocumentTable"
})

export default class extends Vue {

  @Prop({ required: true }) private data: LoadingPlanListTableRowData[];
  @Prop({ required: true }) private tableName: string;
  @Prop({ required: false, default: false }) private selectable: boolean;
  private data_: LoadingPlanListTableRowData[] = [];
  private loadingPlanProduct: ProductInfoModel[] = [];
  selection: LoadingPlanListTableRowData[] = [];

  @Watch("data", { deep: true, immediate: true })
  private watchData() {
    this.data_ = [];
    this.data_.push(...this.data);
  }

  private handleSelectionChange(rows) {
    this.selection = rows;
  }

  private async getProduct(id: string) {
    const product: any = await getLoadingPlanProduct(id);
    this.loadingPlanProduct = product;
  }
}

export class LoadingPlanListTableRowData {
  id: string;
  code: string;
  createdDate: string;
  containerType: string;
  type: LoadingPlanType;
  category: string;
  loadingPlace: string;
  containerInfo: string;
  totalProductQuantity: number;
  totalAmount: string;
  totalVolume: string;
  select: boolean;


  isMatch(code?: string, category?: string, factoryName?: string): boolean {
    let match = true;
    if (!isEmpty(code)) {
      match = this.code.includes(toUpper(code));
    }
    if (!isEmpty(category)) {
      match = match && this.category === category;
    }
    if (!isEmpty(factoryName)) {
      match = match && this.loadingPlace.includes(factoryName);
    }
    return match;
  }
}
